import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = (background, videoWidth, withHover, withLink) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      pathwayWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: 240,
        borderRadius: 5,
        background:
          background === 'Dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
        '&::before, &::after': {
          width: '100%',
          border: '2px solid #4E4766',
          height: '100%',
          content: '""',
          display: 'block',
          zIndex: -1,
          position: 'absolute',
          background: '#23202E',
          borderRadius: 5,
        },
        '&::before': {
          top: -20,
          left: 20,
        },
        '&::after': {
          top: -10,
          left: 10,
        },

        [theme.breakpoints.up('md')]: {
          height: '100%',

          ...(withHover && {
            '&:hover': {
              '& $imgWrap': {
                '&::after': {
                  height: 180,
                },
              },

              '& $title': {
                width: `${videoWidth + videoWidth * 0.2 - 27 * 2}px`,
              },

              '& $description': {
                width: `${videoWidth + videoWidth * 0.2 - 27 * 2}px`,
                fontSize: 16,
                lineHeight: '22px',
                marginBottom: 9,
                overflow: 'hidden',
                whiteSpace: 'inherit',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                '-webkit-line-clamp': '3',
                '-webkit-box-orient': 'vertical',
              },
            },
          }),
        },
      },
      wrap: {
        borderRadius: 5,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        position: 'relative',
      },
      imgWrap: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 198,
        transition: 'none',
        cursor: withHover || withLink ? 'pointer' : 'auto',

        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          left: 0,
          bottom: -3,
          width: '100%',
          height: 133,
          background:
            background === 'Dark'
              ? 'linear-gradient(0deg, rgba(35, 32, 46, 1) 0%, rgba(36, 34, 47, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat'
              : 'linear-gradient(0deg, rgba(27, 25, 37, 1) 0%, rgba(28, 27, 38, 0.9) 17%, rgba(45, 50, 56, 0) 100%) 0% 0% no-repeat',
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
          zIndex: 0,
        },

        [theme.breakpoints.up('md')]: {
          height: 246,
        },
      },
      link: {
        color: 'inherit',
      },
      imageLazyWrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
      },
      videoImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      textWrap: {
        padding: '0 24px 24px 24px',
        zIndex: 1,
        [theme.breakpoints.up('md')]: {
          padding: '0 32px 32px 32px',
        },
      },
      catDifWrap: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        marginBottom: 12,
        zIndex: 1,
        '& > div:not(:last-child)': {
          marginRight: 9,
        },
        '& > a': {
          marginRight: 9,
        },
        [theme.breakpoints.up('md')]: {
          padding: '0 32px',
        },
      },
      title: {
        width: `${videoWidth - 27 * 2}px`,
        fontSize: 18,
        lineHeight: '22px',
        fontWeight: 'bold',
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        marginBottom: 12,
        cursor: withHover || withLink ? 'pointer' : 'auto',
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          lineHeight: '28px',
        },
      },
      description: {
        display: 'none',
      },
      duration: {
        fontSize: 12,
        lineHeight: '15px',
        color: colorsPalette.violet,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
          lineHeight: '18px',
        },
      },
    });
  });

export default useStyles;
